<template>
  <Loading :loading="loading">
    <div v-if="upgradeInfo">
      <div v-if="$store.state.auth.memberLevel == 'silver'">
        <p>
          You are a silver member try the
          <router-link :to="{name:'accountGoldUpgrade'}">Gold Upgrade page</router-link> instead.
        </p>
      </div>
      <div v-else>
        <h2>Membership Renewal</h2>
        <span>
          <p v-html="expiryDate"></p>
        </span>
        <p v-if="upgradeInfo.points_value && upgradeInfo.points_value > 0">
            Your renewal cost has been reduced by {{CurrencyFormatter(upgradeInfo.points_value)}} because you have earned {{upgradeInfo.points_amount}} points.
        </p>

        <p>Renew your Cherrytree Gold membership for another year for {{CurrencyFormatter(upgradeInfo.price)}}.</p>
        <ButtonWithLoading text="Renew Now" state="null" @click.native="upgradeToGold"/>
      </div>
    </div>
  </Loading>
</template>

<script>
import { fetchUpgradeInfo, fetchUserDetails } from "@/network/userRequests";
import { postPurchaseGoldMembership } from "@/network/cartRequests";
import { CurrencyFormatter } from "@/utils";

import ButtonWithLoading from "@/components/buttonWithLoading";
import Loading from "@/components/loading/Loading";

export default {
	name: "myAccountGoldUpgrade",
	components: {
		ButtonWithLoading,
		Loading
	},
	data() {
		return {
			loading: true,
			upgradeInfo: null,
			userID: ""
		};
	},
	created() {
		this.getData();
	},
	methods: {
		CurrencyFormatter,

		getData() {
			this.loading = true;
			fetchUpgradeInfo()
				.then(response => {
				this.upgradeInfo = response;
				this.loading = false;
				})
				.catch(() => {
				// console.log("error getting upgrade price");
				this.loading = false;
				});
			fetchUserDetails(userDetails => this.userID = userDetails.member_details.account_id_fk );
		},
		upgradeToGold() {
			this.$gtm.trackEvent({
				event: 'goldRenew',
				value: this.userID
			});
			postPurchaseGoldMembership().then(result => {
				if (result.success) {
				this.$router.push({
					name: "payment",
					params: { paymentUrl: result.url }
				});
				}
			});
		}
	},
	computed: {
		expiryDate(){
			let d = new Date(this.upgradeInfo.expiry_date)
			if(d instanceof Date && !isNaN(d)){
				return "Your membership expires on"+ d.toDateString()+"."
			}
			return "Your membership has expired."
		}
	}
};
</script>

<style lang="scss">
</style>
